import {
  differenceInCalendarDays,
  differenceInCalendarMonths,
  differenceInDays,
  isValid,
  parseISO,
} from 'date-fns';

export const minBatteryLevel = {
  FRED04: 9.5,
  FRED06: 3.7,
  FREDONE: 10.5,
  SIGICOM: 11.7,
  NEWSIGICOM: 13.8,
};

export const minBatteryWarning = (model, instrumentBattery) => {
  return (
    instrumentBattery !== null && instrumentBattery <= minBatteryLevel[model]
  );
};

/**
 * Check if the status date is withing the accepted time.
 * @param {string | date | null | undefined} lastStatusActivity
 * @returns {boolean}
 */
export const lastStatusActivityWarning = (lastStatusActivity) => {
  return (
    !lastStatusActivity ||
    differenceInDays(new Date(), parseISO(lastStatusActivity)) >= 1
  );
};

export const minCapacityWarning = (model, instrumentCapacity) => {
  if (instrumentCapacity === null) {
    return;
  }

  const threshold = model === 'SIGICOM' ? 50 : 25;

  return instrumentCapacity <= threshold;
};

/**
 * Checks how far off the given date is and returns a numerical representation.
 *
 * @param {Date|string} value - The calibration date to check. Can be a Date object or ISO string.
 *
 * @returns {number}
 *   - 3: If the date is invalid or already expired (today >= calibration date)
 *   - 2: If the calibration date is within 14 days
 *   - 1: If the calibration date is within 2 months
 *   - 0: If the calibration date is more than 2 months away
 */
export const calibrationDateWarning = (value) => {
  const today = new Date();

  const isoValue = value instanceof Date ? value : parseISO(value);
  if (!isValid(isoValue) || today >= isoValue) {
    return 3;
  }

  if (differenceInCalendarDays(isoValue, today) <= 14) {
    return 2;
  }

  if (differenceInCalendarMonths(isoValue, today) <= 2) {
    return 1;
  }

  return 0;
};

export const sensorCalibrationDateWarning = (value) => {
  const today = new Date();

  const isoValue = value instanceof Date ? value : parseISO(value);
  if (!isValid(isoValue) || today >= isoValue) {
    return 3;
  }

  if (differenceInCalendarDays(isoValue, today) <= 7) {
    return 2;
  }

  if (differenceInCalendarMonths(isoValue, today) <= 1) {
    return 1;
  }

  return 0;
};
